import {ControllerQueryModel} from "./controller-query.model";
import {ControllerQueryOrderByModel} from "./controller-query-order-by.model";

export class ControllerQuery {

  static defaultPageSize = 10;

  private _query: any;
  private _maxResults: number = ControllerQuery.defaultPageSize;
  private _firstResult = 0;
  private _sortOrder: ControllerQueryOrderByModel[] = [];

  constructor() {}

  getQuery(): any {
    return this._query;
  }

  query(query: any) {
    this._query = query;
  }

  noResultLimit() {
    this._maxResults = 9007199254740992;
  }

  getMaxResults(): number {
    return this._maxResults;
  }

  maxResults(maxResults: number) {
    this._maxResults = maxResults;
  }

  getFirstResults(): number {
    return this._firstResult;
  }

  firstResult(firstResult: number) {
    this._firstResult = firstResult;
  }

  getSortOrder(): ControllerQueryOrderByModel[] {
    return this._sortOrder;
  }

  sortOrder(sortOrder: ControllerQueryOrderByModel[]) {
    this._sortOrder = sortOrder;
  }

  toQueryModel(): ControllerQueryModel {
      return {
        query: this._query,
        firstResult: this._firstResult,
        maxResults: this._maxResults,
        sortOrder: this._sortOrder
      };
  }
}
